import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Mail } from 'lucide-react';

function SendEmailNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const templateName = (config.templateName as string) || (config.templateId as string) || '';

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-indigo-500 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-indigo-500" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Mail size={14} className="text-indigo-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Send Email
        </span>
      </div>
      <div className="px-3 py-2">
        <p className="text-xs text-zinc-500">Template</p>
        <p className="text-xs text-zinc-800 font-medium truncate">
          {templateName || <span className="italic text-zinc-400">Not set</span>}
        </p>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-indigo-500" />
    </div>
  );
}

export default memo(SendEmailNode);
